export default __webpack_public_path__ + "static/media/search.fc252cc1.svg";